import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { getUserEntity } from 'common/UserEntityProvider';
import InvoicesSearchBar from './InvoicesSearchBar';
import InvoicesStatusSelect from './InvoicesStatusSelect';
import InvoicesAmountRange from './InvoicesAmountRange';
import DateRangePickerDialog from 'components/DateRangePickerDialog';
import Grid from '@mui/material/Grid';
import SearchButton from 'components/common/SearchButton';
import PlusButton from 'components/common/PlusButton';
import { ENTITY_TYPE } from 'common/constants';

const InvoicesNavbar = ({ onSearch, invoiceStatus, allInvoices, showPlusButton = false }) => {

    const [queryString, setQueryString] = useState<string>('');
    const [amounts, setAmounts] = useState({
        "min": "",
        "max": ""
    })
    const [idStatus, setIdStatus] = useState(null);
    const [range, setRange] = useState(null);
    const location = useLocation();

    const handleSearchButton = () => {
        if(range?.from){
            range?.from == "Invalid Date" ? range.from = null : range.from 
        }
        if(range?.to){
            range?.to == "Invalid Date" ? range.to = null : range.to 
        }
        onSearch(queryString, idStatus, range, amounts);
    };

    const handleSearchButtonValidating = () => {
        onSearch(queryString, idStatus);
    };

    const handleStatusChange = (e) => {
        if (e !== null) {
            setIdStatus(e.target.value);
        } else {
            setIdStatus(null);
        }
    };

    useEffect(() => {
        setRange(null);
        setIdStatus(null);
        setAmounts({
            "min": "",
            "max": ""
        })
      }, [location.pathname]);

      const entityType = getUserEntity().entityType;

    return (<>
        <Grid container md={12} gap={1} justifyContent="space-between">
            <Grid md={allInvoices ? 2 : 10}>
                <InvoicesSearchBar 
                    onEnterPress={allInvoices ? handleSearchButton : handleSearchButtonValidating}
                    queryString={queryString}
                    setQueryString={setQueryString}
                />
            </Grid>
            { allInvoices && <Grid md={3.5}>
                <DateRangePickerDialog
                    disabled={false}
                    inputName="dateRange"
                    className='timesheet-datepicker'
                    selected={range}
                    setRange={setRange}
                    required
                    gap={0.5}
                />
            </Grid>
            }
            {
                allInvoices ?
                <Grid md={2} >
                    <InvoicesStatusSelect 
                        invoiceStatus={invoiceStatus} 
                        selectedStatus={idStatus} 
                        handleStatusChange={handleStatusChange} 
                    />
                </Grid>
                :
                <></>
            }
            { allInvoices && <Grid md={2.5} >
                <InvoicesAmountRange 
                    amounts={amounts} 
                    setAmounts={setAmounts}
                    gap={0.5}
                /> 
            </Grid>
            }
            <Grid md={1} >
                <SearchButton clickEvent={allInvoices ? handleSearchButton : handleSearchButtonValidating}/>
            </Grid>
            {showPlusButton && (
                <Grid md={0.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <PlusButton link={entityType === ENTITY_TYPE.CORPORATE_ENTITY ? '/invoicing/newinvoice' : '/myInvoices/upload'} tooltip="invoice.new"/>
                </Grid>
            )}
        </Grid>
    </>);
}

export default InvoicesNavbar;
